import { ArrowUpRight, BookOpen, Images } from "lucide-react";
import { EncabezadoSeccion, Reveal, Marquee } from "../../shared/motion";

export function EnlacesSeccion({ datos, seccion }) {
  const enlaces = datos.enlaces || [];
  if (enlaces.length === 0) return null;

  return (
    <section className="cv-seccion" aria-label={seccion.titulo}>
      <div className="cv-seccion-interior">
        <EncabezadoSeccion p="cv" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="cv-titulo-enlaces" />
        <Reveal>
          <div className="cv-enlaces">
            {enlaces.map((enlace, i) => (
              <a
                key={i}
                className="cv-boton"
                href={enlace.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`cv-enlace-adicional-${i}`}
              >
                {enlace.texto}
                <ArrowUpRight strokeWidth={1.5} />
              </a>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function AccesosSeccion({ datos, seccion, acciones }) {
  const accesos = datos.accesos || {};
  const items = [
    accesos.libroFirmas && {
      icono: BookOpen,
      datos: accesos.libroFirmas,
      alHacer: acciones?.onAbrirLibroFirmas,
      testid: "cv-boton-libro-firmas",
    },
    accesos.album && {
      icono: Images,
      datos: accesos.album,
      alHacer: acciones?.onAbrirAlbumColaborativo,
      testid: "cv-boton-album",
    },
  ].filter(Boolean);
  if (items.length === 0) return null;

  return (
    <section className="cv-seccion" aria-label={seccion.titulo}>
      <div className="cv-seccion-interior">
        <EncabezadoSeccion p="cv" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="cv-titulo-accesos" />
        <Reveal>
          <div className="cv-accesos">
            {items.map((item, i) => (
              <button key={i} type="button" className="cv-acceso" onClick={() => item.alHacer?.()} data-testid={item.testid}>
                <item.icono strokeWidth={1.5} />
                <span>
                  <span className="cv-acceso-titulo">{item.datos.titulo}</span>
                  <span className="cv-acceso-texto" style={{ display: "block" }}>
                    {item.datos.texto}
                  </span>
                </span>
              </button>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function CierreSeccion({ datos }) {
  const { pareja, evento, legal } = datos;

  return (
    <>
      <Marquee
        p="cv"
        textos={[`${pareja.nombre1} & ${pareja.nombre2}`, evento.fechaCorta, evento.ciudad]}
      />
      <section className="cv-seccion cv-cierre" data-testid="cv-cierre">
        <div className="cv-seccion-interior">
          <Reveal>
            <p className="cv-cierre-mensaje">{pareja.mensajeCierre}</p>
            <p className="cv-cierre-nombres">
              {pareja.nombre1} & {pareja.nombre2}
            </p>
            <div className="cv-cierre-legal">
              <span>{legal?.marca}</span>
              {legal?.urlPrivacidad && (
                <a href={legal.urlPrivacidad} target="_blank" rel="noopener noreferrer" data-testid="cv-enlace-privacidad">
                  {legal.textoPrivacidad || "Privacidad"}
                </a>
              )}
              {legal?.urlCondiciones && (
                <a href={legal.urlCondiciones} target="_blank" rel="noopener noreferrer" data-testid="cv-enlace-condiciones">
                  {legal.textoCondiciones || "Condiciones"}
                </a>
              )}
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
